// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2i_iD","right":"styles_right__3yvNi"};